require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./workshops-sketch-storming.json") })
        }
      }, "path---workshops-sketch-storming");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---workshops-sketch-storming!./.cache/json/workshops-sketch-storming.json
// module id = 512
// module chunks = 231608221292675